import { Checkbox } from '@mantine/core';
import { arithmeticOperatorsArray } from '../../../../../../../../../consts/operators';
import ConditionalInput from '../../../ConditionalInput';

export const ArithmeticForm = ({
  columns,
  valueType,
  value,
  onChangeValue,
  onChangeValueType,
  actionType,
  onSelect,
  isSelected,
  isConcatenate,
  formIndex,
  errors
}) => {
  if (actionType === 'operator') {
    return (
      <div
        id={`grid-table-arithmetic-form-operator-${formIndex}`}
        className="operator"
        data-testid={`arithmetic-form-${formIndex}`}
      >
        {isConcatenate && (
          <label id={`grid-table-arithmetic-form-operator-label-${formIndex}`}>Separator</label>
        )}

        <ConditionalInput
          type={isConcatenate ? 'input' : 'column'}
          value={value}
          onChangeValue={onChangeValue}
          onChangeType={onChangeValueType}
          placeholder="Operator"
          hasRequiredError={errors?.includes('operator')}
          required={true}
          columns={arithmeticOperatorsArray.map(el => el.label)}
          hideVariants={true}
          containerProps={{
            style: {
              minWidth: 120
            }
          }}
        />
      </div>
    );
  }

  return (
    <div
      id={`grid-table-arithmetic-form-element-${formIndex}`}
      className="element"
      data-testid={`arithmetic-form-${formIndex}`}
    >
      <div id={`grid-table-arithmetic-form-checkbox-${formIndex}`} className="checkbox_line">
        <Checkbox
          id={`grid-table-arithmetic-form-checkbox-input-${formIndex}`}
          checked={isSelected}
          onClick={onSelect}
          size={16}
        />
      </div>

      <div id={`grid-table-arithmetic-form-input-${formIndex}`} className="input_wrapper">
        <ConditionalInput
          id={`grid-table-arithmetic-form-conditional-${formIndex}`}
          columns={columns}
          type={valueType}
          value={value}
          hasRequiredError={errors?.includes('condition')}
          required={true}
          label={
            isConcatenate
              ? `Column<span style="color:red;">*</span>`
              : `Value<span style="color:red;">*</span>`
          }
          placeholder="Select Column"
          onChangeValue={onChangeValue}
          onChangeType={onChangeValueType}
          hiddenVariants={['null', 'ai_input']}
        />
      </div>
    </div>
  );
};
